import { render, staticRenderFns } from "./ads-superbanner.vue?vue&type=template&id=68ee5166&scoped=true&"
import script from "./ads-superbanner.ts?vue&type=script&lang=js&"
export * from "./ads-superbanner.ts?vue&type=script&lang=js&"
import style0 from "./ads-superbanner.scss?vue&type=style&index=0&id=68ee5166&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ee5166",
  null
  
)

export default component.exports